function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FormattedMessage } from 'react-intl';
import React from 'react';
import InjectionIcon from 'svg/injection.svg';
import MealIcon from 'svg/meal.svg';
import ActivityIcon from 'svg/activity.svg';
import PillsIcon from 'svg/pills.svg';
import tooltipMessages from 'components/RelatedData/messages';
import messages from '../../../../messages';
import RelatedData from './RelatedData';
import Measurement from './Measurement';
export const getTooltipComponent = (tooltipType)=>{
    let TooltipComponent = null;
    switch(tooltipType){
        case 'measurement':
            {
                TooltipComponent = Measurement;
                break;
            }
        case 'related':
            TooltipComponent = RelatedData;
            break;
        default:
            TooltipComponent = null;
    }
    return TooltipComponent;
};
export const getLabel = (element, tooltipType)=>{
    const navLabel = tooltipType === 'related' ? /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, tooltipMessages[element.type].label)) : /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.measurement));
    let icon = null;
    switch(element.type){
        case 'food':
            icon = /*#__PURE__*/ _jsx(MealIcon, {});
            break;
        case 'activity':
            icon = /*#__PURE__*/ _jsx(ActivityIcon, {});
            break;
        case 'pill':
            icon = /*#__PURE__*/ _jsx(PillsIcon, {});
            break;
        case 'injection':
            icon = /*#__PURE__*/ _jsx(InjectionIcon, {});
            break;
        default:
            icon = null;
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                children: icon
            }),
            navLabel
        ]
    });
};
